// extracted by mini-css-extract-plugin
export default {"button":"EditButton_button__B+YxI","icon":"EditButton_icon__iw2Gj"};